import { render, staticRenderFns } from "./OnePageLayout.vue?vue&type=template&id=8832822a"
import script from "./OnePageLayout.vue?vue&type=script&lang=js"
export * from "./OnePageLayout.vue?vue&type=script&lang=js"
import style0 from "./OnePageLayout.vue?vue&type=style&index=0&id=8832822a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports